import { apiClient } from './apiClient';

export async function generateSoulmateImage(prompt: string, size: string = '1024*1024') {
  const data = await apiClient.postJSON<{ url: string; taskId: string }>(
    '/ai/soulmate-image',
    { prompt, size }
  );
  return data;
}